/**
 * Not selected for placeholder
 */
export const NOT_SELECTED = "NOT_SELECTED";
  
/**
  * System admin role
  */
export const SYSTEM_ADMIN_ROLE = "system-admin";

/**
  * Api admin user
  */
export const API_ADMIN_USER = "api-admin";

/**
 * Metaform manager role
 */
export const METAFORM_MANAGER_ROLE = "metaform-manager";

/**
 * Status field name
 */
export const STATUS_FIELD_NAME = "status";

/**
 * Created field name
 */
export const CREATED_FIELD_NAME = "created";

/**
 * Modified field name
 */
export const MODIFIED_FIELD_NAME = "modified";